<div class="err text-danger small">

    @if(control && control.touched && control.errors){
    @if(control.errors.required){
    <div>*Required</div>
    }
    @if(control.errors.maxlength){
    <div> *Maximum length {{control.errors.maxlength.requiredLength}} characters </div>
    }
    @if(control.errors.minlength){
    <div> *Minimum length {{control.errors.minlength.requiredLength}} characters </div>
    }
    @if(control.errors.min){
    <div> *Min {{control.errors.min.min}} </div>
    }
    @if(control.errors.max){
    <div> *Max {{control.errors.max.max}} </div>
    }
    @if(control.errors.email || control.errors.pattern?.requiredPattern == emailRegex){
    <div> *Invalid email format </div>
    }
    @if(control.errors.password || control.errors.pattern?.requiredPattern == passwordRegex){
    <div> *Invalid format, must be 8 characters (at least one capital letter, one symbol and one number) </div>
    }
    @if(control.errors.phoneNumberInvalid){
    <div> *Invalid phone number format </div>
    }
    @if(control.errors.validatePhoneNumber){
    <div> *Please enter a valid phone number </div>
    }
    @if(control.errors.agencyImage || control.errors.truckImage || control.errors.truckTypeImage ||
    control?.errors?.invalidImageType){
    <div> *Invalid Image Format please choose png, jpg, jpeg </div>
    }
    @if(control.errors.website || control.errors.pattern?.requiredPattern == urlRegex){
    <div> *Invalid Url format </div>
    }
    @if(control.errors.driving_licence || control.errors?.invalidLicenceFileType){
    <div> *Invalid File extension </div>
    }
    @if(control.errors.driving_licence || control.errors?.invalidLicenceFileDimensions){
    <div> *Invalid File Dimenstions </div>
    }
    }
</div>
